import dayjs from "dayjs";
import "dayjs/locale/ja";


export function getNextChargeDate():string{
// indexが0から始まるため1月はmonth()だと0で返ってくる
const nextmonth = dayjs().add(2, 'M')
return `${nextmonth.year()}年${nextmonth.month()}月1日`
}
